/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMedicalKit = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M13 13h2v2h-2v2h-2v-2H9v-2h2v-2h2z" />
        <path
          clipRule="evenodd"
          d="M18 7h4v14H2V7h4V3h12zM4 19h2V9H4zm4 0h8V9H8zm10 0h2V9h-2zM8 7h8V5H8z"
          fillRule="evenodd"
        />
      </g>
    </g>
  </Icon>
);
export { SvgMedicalKit as MedicalKit };
